module.exports = __webpack_public_path__ + "static/media/lt-surge-2.5d865952.wav";